// extracted by mini-css-extract-plugin
export default {"topic-node-wrapper":"NodeWrapper_topic-node-wrapper__sOA5z","align-top":"NodeWrapper_align-top__UKS63","justify-left":"NodeWrapper_justify-left__2OD6Q"};